module.exports = __webpack_public_path__ + "static/img/test_qr_code_01.0fec743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test_qr_code_01.png
// module id = wJ9/
// module chunks = 1